import { Link } from "react-router";
import type { DataForCollectionPage } from "~/routes/storefront/products/splat";
import ProductCard from "../product/product-card";

export default function CollectionPage({
	data,
}: {
	data: DataForCollectionPage;
}) {
	const { items, title, description, sections } = data;

	return (
		<div className="container mx-auto space-y-4 px-4 py-8 sm:px-6 md:py-16 lg:px-8">
			<div>
				<h1 className="text-5xl text-primary tracking-tight">{title}</h1>

				{description && (
					<div
						className="mx-auto mt-4 text-base text-gray-500"
						// biome-ignore lint/security/noDangerouslySetInnerHtml: <We are getting HTML from Crystallize>
						dangerouslySetInnerHTML={{ __html: description }}
					/>
				)}

				{sections && sections.length > 0 && (
					<nav className="my-6 flex flex-wrap justify-center gap-2 bg-white/80 py-4 backdrop-blur-sm md:gap-4">
						{sections.map((section) => (
							<a
								key={section.slug}
								href={`#${section.slug}`}
								className="transform rounded-3xl bg-primary px-6 py-2 text-white transition-transform hover:scale-105 hover:bg-primary/80"
							>
								{section.subtitle}
							</a>
						))}
					</nav>
				)}
			</div>
			<div className="grid grid-cols-1 gap-8 md:grid-cols-3 lg:gap-24">
				{(() => {
					let idx = 0;
					return sections?.map((section) => (
						<div
							className="grid grid-cols-subgrid gap-8 md:col-span-3"
							key={section.slug}
						>
							<h2
								className="col-span-full scroll-mt-20 border-b pb-4 text-3xl text-primary"
								id={section.slug}
								key={section.slug}
							>
								{section.subtitle}
							</h2>
							{section.items.map((item) => (
								<Link
									key={item.path ?? ""}
									to={item.path ?? "/"}
									prefetch="intent"
									className="flex h-full flex-col overflow-hidden rounded-lg bg-white ring-2 ring-primary/15 transition-all duration-300 hover:ring-primary"
								>
									<ProductCard {...item} index={idx++} />
								</Link>
							))}
						</div>
					));
				})()}

				{items.map((child, index: number) => {
					if (
						child.shape === "dish" ||
						child.shape === "menu" ||
						child.shape === "default-product"
					) {
						return (
							<Link
								key={child.path ?? ""}
								to={child.path ?? "/"}
								prefetch="intent"
								className="flex h-full flex-col overflow-hidden rounded-lg bg-white ring-2 ring-primary/15 transition-all duration-300 hover:ring-primary"
							>
								<ProductCard {...child} index={index} />
							</Link>
						);
					}
					return null;
				})}
			</div>
		</div>
	);
}
